import {
  PolarAngleAxis,
  RadialBar,
  RadialBarChart,
} from "recharts";

type DealUrgencyBucket = "low" | "medium" | "high";

interface DealUrgencyGaugeProps {
  bucket: DealUrgencyBucket;
}

const URGENCY_CONFIG: Record<DealUrgencyBucket, { value: number; color: string; label: string }> = {
  low: {
    value: 1,
    color: "#0D6E55",
    label: "Low",
  },
  medium: {
    value: 3,
    color: "#7B6FA4",
    label: "Medium",
  },
  high: {
    value: 5,
    color: "#9B3A46",
    label: "High",
  },
};

export function DealUrgencyGauge({ bucket }: DealUrgencyGaugeProps) {
  const urgency = URGENCY_CONFIG[bucket];
  const accessibleLabel = `${urgency.label} urgency`;

  return (
    <div
      className="relative h-[50px] w-[68px] shrink-0 overflow-visible"
      aria-label={accessibleLabel}
      title={accessibleLabel}
    >
      <RadialBarChart
        width={68}
        height={44}
        cx={34}
        cy={33}
        data={[{ value: urgency.value }]}
        innerRadius={20}
        outerRadius={27}
        startAngle={180}
        endAngle={0}
        className="absolute left-0 top-0"
      >
        <PolarAngleAxis
          type="number"
          domain={[0, 6]}
          tick={false}
        />
        <RadialBar
          dataKey="value"
          cornerRadius={6}
          background={{ fill: "#E5E7EB" }}
          fill={urgency.color}
        />
      </RadialBarChart>
      <span
        className="absolute left-1/2 top-[29px] -translate-x-1/2 text-[9px] font-semibold uppercase"
        style={{ color: urgency.color }}
      >
        {urgency.label}
      </span>
      <span className="sr-only">{accessibleLabel}</span>
    </div>
  );
}
